import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuth } from '~/context/auth';
import { DEFAULT_LIST_OFFSET } from '~/data/constants';
import { CustomPage } from '~/data/models/yearbook';
import { CUSTOM_PAGES_INSTANCES_RESULT } from '~/data/operations/yearbook';
import { YearbookStackParamList } from '~/navigation/types';
import CustomPageResultsLayout from './layout';

type CustomPageResultsNavProp = StackNavigationProp<
  YearbookStackParamList,
  'CustomPageResults'
>;

type CustomPageResultsRouteProp = RouteProp<
  YearbookStackParamList,
  'CustomPageResults'
>;
export default function CustomPageResults(): JSX.Element {
  const navigation = useNavigation<CustomPageResultsNavProp>();
  const {
    params: { moduleInstanceId },
  } = useRoute<CustomPageResultsRouteProp>();
  const { authUserId } = useAuth();
  const [userCustomPages, setUserCustomPages] = useState<CustomPage[]>([]);

  const customPageVar = {
    after: null,
    first: DEFAULT_LIST_OFFSET,
    moduleInstance: moduleInstanceId,
  };

  const {
    data: customPagesData,
    loading: customPagesLoading,
    refetch: refetchCustomPages,
    fetchMore: fetchMoreCustomPages,
  } = useQuery(CUSTOM_PAGES_INSTANCES_RESULT, {
    variables: customPageVar,
  });

  const customPagesInstances: CustomPage[] =
    (customPagesData?.customPagesInstancesResult?.edges.map(
      (edge) => edge?.node,
    ) as CustomPage[]) || [];
  const hasNextPage =
    customPagesData?.customPagesInstancesResult?.pageInfo.hasNextPage;
  const endCursor =
    customPagesData?.customPagesInstancesResult?.pageInfo.endCursor;

  useEffect(() => {
    if (!customPagesLoading && customPagesData) {
      // Filter custom pages where the current user is the owner
      const filteredPages = customPagesInstances.filter(
        (page) => page?.userGroup?.user.id === authUserId,
      );
      setUserCustomPages(filteredPages || []);
    }
  }, [customPagesData, customPagesLoading]);
  return (
    <CustomPageResultsLayout
      onBack={() => navigation.goBack()}
      hasNextPage={hasNextPage}
      userCustomPages={userCustomPages}
      onRefresh={refetchCustomPages}
      loading={customPagesLoading}
      onLoadMore={() => {
        fetchMoreCustomPages({
          variables: {
            ...customPageVar,
            after: endCursor,
          },
        });
      }}
      onOpenCustomPage={(customPageId: string) =>
        navigation.navigate('CustomPageResult', {
          moduleInstanceId: moduleInstanceId,
          customPageId,
        })
      }
    />
  );
}
